import { styled } from '@mui/system';

import { Paper, Typography, Box } from '@mui/material';

import { fontFamilies } from '../../constants/theme';
const gradientColor =
  'rgba(82, 31, 12, 0) 0%, rgba(82, 31, 12, 0) 15%, rgba(82, 31, 12, 0) 31%, rgba(82, 31, 12, 0.07) 46%, rgba(82, 31, 12, 0.45) 65%, rgba(82, 31, 12, 0.44) 85%, rgba(82, 31, 12, 1) 98%';
export const StepCardPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
  maxWidth: '198px',
  borderRadius: '40px',
  padding: '10px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',

  [theme.breakpoints.down('xl')]: {
    borderRadius: '36px',
    padding: '9px',
  },

  [theme.breakpoints.down('lg')]: {
    borderRadius: '32px',
    padding: '8px',
  },

  [theme.breakpoints.down('md')]: {
    borderRadius: '28px',
    padding: '7px',
  },

  [theme.breakpoints.down('sm')]: {
    borderRadius: '24px',
    padding: '6px',
  },

  [theme.breakpoints.down(500)]: {
    borderRadius: '20px',
    padding: '5px',
  },
}));

export const AccentBorder = styled(Box)(({ theme, accent }) => ({
  position: 'absolute',
  inset: 0,
  borderRadius: '24px',
  pointerEvents: 'none',
}));

export const StepCardBackground = styled(Box)(({ theme, accent }) => ({
  position: 'relative',
  borderRadius: '40px',
  background:
    accent === 'top'
      ? `linear-gradient(10deg, ${gradientColor})`
      : `linear-gradient(180deg, ${gradientColor})`,
  padding: '1px',
  width: '200px',
  height: '200px',
  flexShrink: 0,

  [theme.breakpoints.down('xl')]: {
    width: '180px',
    height: '180px',
    borderRadius: '36px',
  },

  [theme.breakpoints.down('lg')]: {
    width: '160px',
    height: '160px',
    borderRadius: '32px',
  },

  [theme.breakpoints.down('md')]: {
    width: '140px',
    height: '140px',
    borderRadius: '28px',
  },

  [theme.breakpoints.down('sm')]: {
    width: '120px',
    height: '120px',
    borderRadius: '24px',
  },

  [theme.breakpoints.down(500)]: {
    width: '100px',
    height: '100px',
    borderRadius: '20px',
  },
}));

const textStyles = {
  fontSize: '18px',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'center',
  fontWeight: 500,
  fontFamily: fontFamilies.gotham,
  margin: '14px 0px',
  whiteSpace: 'pre-line',
  lineHeight: 1.2,
  minHeight: '70px',
};

export const StepText = styled(Typography)(({ theme }) => ({
  ...textStyles,

  [theme.breakpoints.down('xl')]: {
    fontSize: '16px',
    margin: '12px 0px',
    minHeight: '60px',
  },

  [theme.breakpoints.down('lg')]: {
    fontSize: '14px',
    margin: '10px 0px',
    minHeight: '50px',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    margin: '8px 0px',
    minHeight: '42px',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
    margin: '6px 0px',
    minHeight: '34px',
  },

  [theme.breakpoints.down(500)]: {
    fontSize: '8px',
    margin: '4px 0px',
    minHeight: '28px',
  },
}));

export const StepTextBottom = styled(Typography)(({ theme }) => ({
  ...textStyles,

  [theme.breakpoints.down('xl')]: {
    fontSize: '16px',
    margin: '12px 0px',
    minHeight: '60px',
  },

  [theme.breakpoints.down('lg')]: {
    fontSize: '14px',
    margin: '10px 0px',
    minHeight: '50px',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    margin: '8px 0px',
    minHeight: '42px',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
    margin: '6px 0px',
    minHeight: '34px',
  },

  [theme.breakpoints.down(500)]: {
    fontSize: '8px',
    margin: '4px 0px',
    minHeight: '28px',
  },
}));
